import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  setFormLoading,
  setFormDataToStore,
  setVariantCuisineTypeId,
  setVariantDescription,
  setVariantFormTypeId,
  setVariantImagePath,
  setVariantIsActive,
  setVariantIsSpecial,
  setVariantIsVeg,
  setVariantMealTypeId,
  setVariantMicrowaveHeatingRequired,
  setVariantName,
  setVariantProductId,
  setVariantQuantityTypeId,
  setVariantQuantityValue,
  setVariantServing,
  setVariantShelfLife,
  setVariantTaxTypeId,
  setVariantTitle,
  setVariantWithPackagingWeight,
  setSubmitLoading
} from './actions';
import parseResponseToOptions,{ parseTaxTypesOptions  } from '../../utils/parseResponseToOptions';
import {parseOptionsWithUpdatedDate} from '../../utils/parseResponseToOptions.jsx';
import CreateVariantComponent from './component';

class CreateVariantContainer extends Component {
  componentDidMount() {
    this.props.setFormLoading(true);
    this.props.getDataFromAPI(
      '/form/dropdowns',
      'GET',
      undefined,
      response => {
        console.log(response);
        this.props.setFormDataToStore(response);
        this.props.setFormLoading(false);
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer details');
        this.props.setFormLoading(true);
      }
    );
  }

  // fields handler
  onChangeOfName = event => {
    this.props.setVariantName(event.target.value);
  };

  onChangeOfDescription = event => {
    this.props.setVariantDescription(event.target.value);
  };

  onChangeOfTitle = event => {
    this.props.setVariantTitle(event.target.value);
  };

  onChangeOfCuisineType = (event, data) => {
    this.props.setVariantCuisineTypeId(data.value);
  };

  onChangeOfFormType = (event, data) => {
    this.props.setVariantFormTypeId(data.value);
  };

  onChangeOfMealType = (event, data) => {
    this.props.setVariantMealTypeId(data.value);
  };

  onChangeOfProduct = (event, data) => {
    this.props.setVariantProductId(data.value);
  };

  onChangeOfImagePath = event => {
    this.props.setVariantImagePath(event.target.value);
  };

  onChangeOfIsActive = (event, data) => {
    this.props.setVariantIsActive(datavalue);
  };

  onChangeOfIsSpecial = (event, data) => {
    this.props.setVariantIsSpecial(data.value);
  };

  onChangeOfIsVeg = (event, data) => {
    this.props.setVariantIsVeg(data.value);
  };

  onChangeOfMicrowaveHeating = event => {
    this.props.setVariantMicrowaveHeatingRequired(parseInt(event.target.value, 10));
  };

  onChangeOfQuantityTypeId = (event, data) => {
    this.props.setVariantQuantityTypeId(data.value);
  };

  onChangeOfQuantityValue = event => {
    this.props.setVariantQuantityValue(parseInt(event.target.value, 10));
  };

  onChangeOfServing = event => {
    this.props.setVariantServing(parseInt(event.target.value, 10));
  };

  onChangeOfShelfLife = event => {
    this.props.setVariantShelfLife(parseInt(event.target.value, 10));
  };

  onChangeOfTaxTypeId = (event, data) => {
    this.props.setVariantTaxTypeId(data.value);
  };

  onChangeOfPackageWeight = event => {
    this.props.setVariantWithPackagingWeight(parseInt(event.target.value, 10));
  };

  handleSubmit = () => {
    this.props.setSubmitLoading(true);
    const {
      name,
      title,
      description,
      productId,
      quantityTypeId,
      formTypeId,
      mealTypeId,
      cuisineTypeId,
      taxTypeId,
      isSpecial,
      isVeg,
      isActive,
      shelfLife,
      serving,
      microwaveHeatingRequired,
      quantityValue,
      withPackagingWeight,
      imagePath
    } = this.props.createVariant;

    const payload = {
      name,
      title,
      description,
      productId,
      quantityTypeId,
      formTypeId,
      mealTypeId,
      cuisineTypeId,
      taxTypeId,
      isSpecial,
      isVeg,
      isActive,
      shelfLife,
      serving,
      microwaveHeatingRequired,
      quantityValue,
      withPackagingWeight,
      imagePath
    };

    this.props.getDataFromAPI(
      '/products/variants/new',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Added New Variant');
        this.props.setSubmitLoading(false);
        return this.props.history.push('/products');
      },
      err => {
        this.props.setSubmitLoading(false);
      }
    );
  };

  render() {
    const formData = this.props.createVariant && this.props.createVariant.formData;
    const submitLoading = this.props.createVariant && this.props.createVariant.submitLoading;

    return (
      <CreateVariantComponent
        loading={this.props.createVariant && this.props.createVariant.loading}
        cuisineTypesDD={parseResponseToOptions(formData.cuisineTypes)}
        formTypesDD={parseResponseToOptions(formData.formTypes)}
        mealTypesDD={parseResponseToOptions(formData.mealTypes)}
        quantityTypesDD={parseResponseToOptions(formData.quantityTypes)}
        taxTypesDD={parseTaxTypesOptions(formData.taxTypes)}
        productsDD={parseOptionsWithUpdatedDate(formData.products)}
        onChangeOfCuisineType={this.onChangeOfCuisineType}
        onChangeOfDescription={this.onChangeOfDescription}
        onChangeOfFormType={this.onChangeOfFormType}
        onChangeOfImagePath={this.onChangeOfImagePath}
        onChangeOfIsActive={this.onChangeOfIsActive}
        onChangeOfIsSpecial={this.onChangeOfIsSpecial}
        onChangeOfIsVeg={this.onChangeOfIsVeg}
        onChangeOfMealType={this.onChangeOfMealType}
        onChangeOfMicrowaveHeating={this.onChangeOfMicrowaveHeating}
        onChangeOfName={this.onChangeOfName}
        onChangeOfPackageWeight={this.onChangeOfPackageWeight}
        onChangeOfProduct={this.onChangeOfProduct}
        onChangeOfTitle={this.onChangeOfTitle}
        onChangeOfTaxTypeId={this.onChangeOfTaxTypeId}
        onChangeOfServing={this.onChangeOfServing}
        onChangeOfShelfLife={this.onChangeOfShelfLife}
        onChangeOfQuantityValue={this.onChangeOfQuantityValue}
        onChangeOfQuantityTypeId={this.onChangeOfQuantityTypeId}
        submitLoading={submitLoading}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps({ createVariant }) {
  return {
    createVariant
  };
}

export default withRouter(
  connect(mapStateToProps, {
    setFormDataToStore,
    setFormLoading,
    getDataFromAPI,
    setVariantCuisineTypeId,
    setVariantDescription,
    setVariantFormTypeId,
    setVariantImagePath,
    setVariantIsActive,
    setVariantIsSpecial,
    setVariantIsVeg,
    setVariantMealTypeId,
    setVariantMicrowaveHeatingRequired,
    setVariantName,
    setVariantProductId,
    setVariantQuantityTypeId,
    setVariantQuantityValue,
    setVariantServing,
    setVariantShelfLife,
    setVariantTaxTypeId,
    setVariantTitle,
    setVariantWithPackagingWeight,
    setSubmitLoading
  })(CreateVariantContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/CreateNewVariant/container.jsx